/** Matches the backend default page size of `GET /hotels/:hotelId/partners/services`. */
export const GUESTERIA_SERVICES_PAGE_SIZE = 20;

/** Number of pages for `total` items; at least 1 so an empty list keeps a valid page. */
export function getTotalPages(
  total: number | undefined,
  pageSize: number,
): number {
  if (
    total === undefined ||
    !Number.isFinite(total) ||
    total <= 0 ||
    !Number.isFinite(pageSize) ||
    pageSize <= 0
  ) {
    return 1;
  }
  return Math.ceil(total / pageSize);
}

/** Restricts `page` to the range 1..totalPages; non-numeric input becomes 1. */
export function clampPage(page: number, totalPages: number): number {
  if (!Number.isFinite(page)) {
    return 1;
  }
  return Math.min(Math.max(1, Math.trunc(page)), Math.max(1, totalPages));
}
